import { ReportGmailerrorred } from "@mui/icons-material";
import { Box, Skeleton, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { SocketContext } from "../../contexts";

interface ActionProps {
  id: string;
  status: string;
  children: JSX.Element;
}

export const DocumentAction: React.FC<ActionProps> = ({ id, status, children }) => {
  const { receivedEvents } = useContext(SocketContext);

  const [currentStatus, updateStatus] = useState<string>(status);

  useEffect(() => {
    if (currentStatus === "pending") {
      let document = receivedEvents?.["document-status"]?.[id] || {};
      if (currentStatus === "pending" && Object.keys(document).length > 0) {
        if (document?.status === "saved") {
          updateStatus("saved");
        } else {
          updateStatus("failed");
        }
      }
    }
    // eslint-disable-next-line
  }, [receivedEvents?.["document-status"], receivedEvents?.["document-status"]?.[id]]);

  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      {currentStatus === "pending" && <Tooltip title={"Uploading"}>
        <Skeleton width={"20px"} height={"20px"} variant="text" sx={{ px: "8px" }} />
      </Tooltip>}
      {currentStatus === "saved" && (
        <Typography variant="body2">{children}</Typography>
      )}
      {currentStatus === "failed" && (
        <Tooltip title={"Error on Upload"}>
          <ReportGmailerrorred color="error" fontSize="small" />
        </Tooltip>
      )}
    </Box>
  );
};
